import { FlattenObjectValues } from '@csp/csp-common-model';

// General formats
const YYYY_MM_DD = 'yyyy-MM-dd';
const YYYY_MMM_DD = 'yyyy-MMM-dd';
const HH_MM = `HH:mm`;
const HH_MM_SS = `${HH_MM}:ss`;
const HH_MM_SS_SSS = `${HH_MM_SS}:SSS`;
const YYYY_MM_DD_HH_MM = `${YYYY_MM_DD} ${HH_MM}`;
const LLL = 'LLL';
const LLL_DD = `${LLL} dd`;

// ISO 8601 formats
const ISO_8601_DATE_FORMAT = YYYY_MM_DD;
const ISO_8601_TIME_FORMAT = `${HH_MM}:ss`;
const ISO_8601_UTC_OFFSET_FORMAT = 'xxx';
const ISO_8601_DATE_TIME_FORMAT = `${ISO_8601_DATE_FORMAT}'T'${ISO_8601_TIME_FORMAT}.SSS${ISO_8601_UTC_OFFSET_FORMAT}`;

export const ZonedDateTimeFormat = {
  UNIFY: {
    /**
     * General date format e.g. "2021-01-01"
     */
    DATE_FORMAT: YYYY_MM_DD,
    /**
     * General date format with short form month name e.g. "2021-Jan-01"
     */
    DATE_MMM_FORMAT: YYYY_MMM_DD,
    /**
     * General time format e.g. "04:00"
     */
    TIME_FORMAT: HH_MM,
    /**
     * General time format with seconds e.g "04:00:10"
     */
    TIME_FORMAT_SECONDS: HH_MM_SS,
    /**
     * General time format with milliseconds e.g "04:00:10:999"
     */
    TIME_FORMAT_MILLISECONDS: HH_MM_SS_SSS,
    /**
     * General datetime format e.g. "2021-01-01 04:00"
     */
    DATE_TIME_FORMAT: YYYY_MM_DD_HH_MM,
    /**
     * Month stand-alone format in short form e.g. "Jan"
     */
    MONTH_FORMAT: LLL,
    /**
     * Month stand-alone format with day in short form e.g. "Jan 10"
     */
    MONTH_DAY_FORMAT: LLL_DD,
    /**
     * General datetime format with zone e.g. "2021-01-01 04:00 +00:00
     */
    DATE_TIME_UTC_OFFSET_FORMAT: `${YYYY_MM_DD_HH_MM} ${ISO_8601_UTC_OFFSET_FORMAT}`,
    /**
     * General datetime format with zone e.g. "Jan 10 2021, 04:00 +00:00
     */
    MONTH_DAY_YEAR_TIME_UTC_OFFSET_FORMAT: 'MMM dd yyyy, HH:mm xxx',
  },

  ISO_8601: {
    /**
     * ISO 8601 date format e.g. "2021-01-01"
     */
    DATE_FORMAT: ISO_8601_DATE_FORMAT,
    /**
     * ISO 8601 time format e.g. "04:00:00"
     */
    TIME_FORMAT: ISO_8601_TIME_FORMAT,
    /**
     * ISO 8601 UTC offset e.g. "+04:00"
     */
    UTC_OFFSET: ISO_8601_UTC_OFFSET_FORMAT,
    /**
     * ISO 8601 datetime format e.g. "2021-01-01T04:00:00.000+04:00"
     */
    DATE_TIME_FORMAT: ISO_8601_DATE_TIME_FORMAT,
  },
} as const;

export type ZonedDateTimeFormatString = FlattenObjectValues<typeof ZonedDateTimeFormat>;
